import { action, makeAutoObservable, flow } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'


class PospalStore {
    pospals = []
    memberOrders = []
    memberOrderCount = 0
    orders = []
    orderCount = 0

    constructor() {
        makeAutoObservable(this)
    }

    getPospalUser = flow(function* (pospalId, user) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.getPospalUser(pospalId, user, token)
            return Promise.resolve(response.data)
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listPospal = flow(function* () {
        try {
            console.log('list pospal')
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listPospal(token)
            this.pospals = response.data
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listCustomerCategory = flow(function* (pospalId) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listCustomerCategory(pospalId, token)
            return Promise.resolve(response.data)
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    createPospalUser = flow(function* (pospalId, categoryName, name, point, discount, balance, phone, email, shopperUserId) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.createPospalUser(pospalId, token, categoryName, phone, name, point, discount, balance, phone, email, shopperUserId)
            return Promise.resolve(response.data)
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    editPospalUser = flow(function* (pospalId, id, customerUid, categoryName, name, discount, phone, email, enable, shopperUserId) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.editPospalUser(pospalId, id, token, customerUid, categoryName, name, discount, phone, email, enable, shopperUserId)
            return Promise.resolve(response.data)
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listPospalUsers = flow(function* (pospalId, skip, name, email, phone) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const shop = yield AsyncStorage.getItem('shop')
            const response = yield api.listPospalUsers(pospalId, token, skip, shop, name, email, phone)
            return Promise.resolve(response.data)
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

}

export default new PospalStore()